import { SeverityType } from '@shared/enums/SeverityType';

export class SuccessResponse<TData> {
    public data: TData;
    public messages: ErrorResponseMessage[];
}

export class ErrorResponse {
    constructor(public messages: ErrorResponseMessage[]) { }
}

export class ErrorResponseMessage {
    public errorCode: string;
    public errorMessage: string;
    public propertyName: string;
    public severity: SeverityType;
    text?: string;
}
